import React, { Fragment, useState } from 'react'
import { Radio } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import { withRouter } from 'react-router'
import { Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import NewDepartment from './NewDepartment'
import NewRegion from './NewRegion'
import NewShop from './NewShop'
import NewCashRegister from './NewCashRegister'

const NewRecord = props => {
	const [t] = useTranslation()
	const [recordType, setRecordTypeState] = useState('CASH_REGISTER')
	const setRecordType = e => setRecordTypeState(e.target.value)
	let newRecordForm
	switch(recordType) {
		case 'DEPARTMENT':
			newRecordForm = <NewDepartment {...props}/>
			break
		case 'REGION':
			newRecordForm = <NewRegion {...props}/>
			break
		case 'SHOP':
			newRecordForm = <NewShop {...props}/>
			break
		case 'CASH_REGISTER':
			newRecordForm = <NewCashRegister {...props}/>
			break
		case 'TERMINAL':
			newRecordForm = null
			break
		default:
			newRecordForm = null
			break
	}

	return(
		<Fragment>
			<ContentBlock>
				<Col xs={4}>
					<Radio
						noForm
						onChange={setRecordType}
						checked={recordType === 'DEPARTMENT'}
						value='DEPARTMENT'
						label={t('options_section.strings.add_new_department')}
					/>
					<Radio
						noForm
						onChange={setRecordType}
						checked={recordType === 'REGION'}
						value='REGION'
						label={t('options_section.strings.add_new_region')}
					/>
					<Radio
						noForm
						onChange={setRecordType}
						checked={recordType === 'SHOP'}
						value='SHOP'
						label={t('options_section.strings.add_new_branch')}
					/>
					<Radio
						noForm
						onChange={setRecordType}
						checked={recordType === 'CASH_REGISTER'}
						value='CASH_REGISTER'
						label={t('options_section.strings.add_new_cash_register')}
					/>
					{/*<Radio noForm onChange={setRecordType} checked={recordType === 'TERMINAL'} value='TERMINAL' label='Add new Info terminal'/>*/}
				</Col>
			</ContentBlock>
			{recordType !== 'NONE' &&
				<ContentBlock>
					{newRecordForm}
				</ContentBlock>
			}
		</Fragment>
	)
}

export default withRouter(NewRecord)
